import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AuditLog() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/audit-log");
        setEvents(data.events || []);
      } catch (e) {
        setErr(e.response?.data?.detail || "Failed to load audit log");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="vb-fade-in" data-testid="audit-log-page">
      <h1 className="vb-heading text-3xl mb-1" style={{ color: "var(--vb-text-2)" }}>Platform audit log</h1>
      <p className="opacity-70 mb-6">
        Cross-tenant super-admin actions: tier &amp; tenant CRUD, password resets, and support-mode impersonation. Retained for 5 years for ISO 22000 compliance.
      </p>
      {loading && <p className="opacity-60">Loading…</p>}
      {err && <div className="vb-pill err">{err}</div>}
      {!loading && events.length === 0 && (
        <div className="vb-card p-6 opacity-60 text-sm">No audit events yet.</div>
      )}
      {!loading && events.length > 0 && (
        <div className="vb-card overflow-x-auto">
          <table className="vb-table">
            <thead>
              <tr><th>When</th><th>Actor</th><th>Action</th><th>Target</th><th>Details</th></tr>
            </thead>
            <tbody>
              {events.map((e) => (
                <tr key={e.id} data-testid={`audit-row-${e.id}`}>
                  <td className="opacity-70 whitespace-nowrap">{new Date(e.created_at).toLocaleString()}</td>
                  <td>
                    <div className="text-sm">{e.actor_email || e.actor_id || "—"}</div>
                    <div className="text-xs opacity-60">{e.actor_role}</div>
                    {e.support_mode && (
                      <span className="vb-pill warn text-[10px] mt-1 inline-block">support-mode</span>
                    )}
                  </td>
                  <td><code className="text-xs">{e.action}</code></td>
                  <td className="text-xs opacity-80">
                    {e.target_type && <span>{e.target_type}</span>}
                    {e.target_id && <div className="opacity-60">{e.target_id.slice(0, 8)}…</div>}
                  </td>
                  <td className="text-xs opacity-80" style={{ maxWidth: 320 }}>
                    <code style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                      {Object.keys(e.payload || {}).length > 0 ? JSON.stringify(e.payload) : "—"}
                    </code>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
